export const BREAKPOINT_SCROLLING_MENU = 'max-width: 1200px';
